import { getAuth } from "firebase/auth";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

const LOCAL_ERRORS_KEY = "familySyncClientErrors";
const MAX_LOCAL_ERRORS = 20;

const safeSerialize = (value) => {
  try {
    return JSON.parse(JSON.stringify(value));
  } catch (error) {
    return null;
  }
};

const readLocalErrors = () => {
  if (typeof window === "undefined" || !window.localStorage) return [];
  try {
    const raw = window.localStorage.getItem(LOCAL_ERRORS_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

const writeLocalErrors = (entries) => {
  if (typeof window === "undefined" || !window.localStorage) return;
  try {
    window.localStorage.setItem(LOCAL_ERRORS_KEY, JSON.stringify(entries.slice(-MAX_LOCAL_ERRORS)));
  } catch (error) {
    // Ignore local persistence failures.
  }
};

export const reportClientError = async ({ error, info, context = {} }) => {
  const payload = {
    message: String(error?.message || "Unknown error"),
    stack: String(error?.stack || ""),
    componentStack: String(info?.componentStack || ""),
    context: safeSerialize(context) || null,
    page: typeof window !== "undefined" ? window.location.href : null,
    userAgent: typeof navigator !== "undefined" ? navigator.userAgent : null,
    occurredAt: new Date().toISOString()
  };

  const localEntries = [...readLocalErrors(), payload];
  writeLocalErrors(localEntries);

  try {
    const auth = getAuth();
    const user = auth?.currentUser;
    if (!user?.uid) return;
    await addDoc(collection(db, "clientErrors"), {
      ...payload,
      userId: user.uid,
      userEmail: user.email || null,
      createdAt: serverTimestamp()
    });
  } catch (reportError) {
    console.warn("Client error reporting failed", reportError);
  }
};
